export default __webpack_public_path__ + "static/media/60B_60F_60H_60K_60P_60Q_20F_20G_20K.130be9b8.jpg";